var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.61719C3 3.41719 6.40324 0 10.5862 0C14.7692 0 18.1724 3.41719 18.1724 7.61719C18.1724 9.20976 17.688 10.7348 16.7714 12.0277L16.7645 12.0371L16.7637 12.0391C16.2414 12.7386 15.3349 13.9685 14.3511 15.3036C13.1925 16.876 11.9262 18.5942 11.0534 19.7637C10.854 20.0309 10.4496 20.1067 10.1694 19.8055C10.1596 19.7952 10.1476 19.7886 10.1364 19.7805C10.1299 19.7758 10.1238 19.7705 10.1186 19.7637L4.51342 12.1836C3.5229 10.8586 3 9.2793 3 7.61719ZM10.5593 10.6691C8.86914 10.6691 7.49906 9.29261 7.49906 7.5946C7.49906 5.89658 8.86914 4.52007 10.5593 4.52007C12.2495 4.52007 13.6196 5.89658 13.6196 7.5946C13.6196 9.29261 12.2495 10.6691 10.5593 10.6691Z",
    fill: "#90C5C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectLocation);
export default __webpack_public_path__ + "static/media/Project_Location.506c8cf544d3f00103922ea4eb7ec687.svg";
export { ForwardRef as ReactComponent };